<!--
    Usage :
      <ClassPopUp
            date = Date object
            title = "Computing Lab"
            startTime = "9:00am"
            endTime = "10:00am"
            location = "203 Lec Theatre 1 Entrance"
            locationLink = "http://localhost:8081/#/map?buildingId=295&toId=2950203&toType=R"
            onlineClassLink = "www.moodle.com"
            classIf = null // ONLIVE = online class, ONANY = hybrid class, other = in person
            lecturer = "Prof John Smithson"
            classType = "Lecture"
            desc = "revision lecture"
            @close = "togglePopup"
            v-if = "showPopUp"
        />

        ( inside <script>)
        const showPopUp = ref(false)
        function togglePopup() {
            showPopUp.value = !showPopUp.value
        }
-->
<template>
    <NewModalPopup
        :title="formatDateTitle(date)"
        showX="true"
        @close="emit('close')"
        id="classPopUp"
    >
        <p class="title" data-test="title">{{ title }}</p> <!-- date title and time are always provided -->
        <p data-test="times"> {{ formatEventTime(startTime, true) }} - {{ formatEventTime(endTime, true) }}</p>


        <template v-if="!roomBooking">
            <p v-if="location">
                <span v-if="classIf == 'ONLIVE' || classIf == 'ONANY'">
                    <span class="eventLocContainer">
                        <font-awesome-icon class="eventLocIcon" style="margin:auto" icon="fa-link" size="2xl"></font-awesome-icon>
                    </span>
                    <span class="spacer"></span>
                    <a class="jsLink" @click="onlineClassLink" data-test="onlineClassLink">See Moodle</a>
                </span>
                <span v-else>
                    <span class="eventLocContainer">
                        <font-awesome-icon  class="eventLocIcon" icon="fa-location-dot" size="2xl"></font-awesome-icon>
                    </span>
                    <span class="spacer"></span>
                    <a v-if="locationLink" :href="locationLink" data-test="physical-location-link"> {{ location }} </a>
                    <p class="no-location" v-else data-test="physical-location"> {{ location }}</p>
                </span>
            </p>
            <p v-else class="not-supplied">Location not supplied</p>

            <p v-if="lecturer" data-test="lecturer">{{ lecturer }}</p>
            <p v-else class="not-supplied">Lecturer data not supplied</p>

            <p v-if="classType" data-test="classType">{{ classType }}</p>
            <p v-else class="not-supplied">Class type not supplied</p>

            <p v-if="desc" data-test="desc">{{ desc }}</p>

        </template>
        <template v-else> <!-- Room bookings -->
            <p>
                <span class="eventLocContainer">
                    <font-awesome-icon  class="eventLocIcon" icon="fa-location-dot" size="2xl"></font-awesome-icon>
                </span>
                <a :href="roomLink">{{ room }}</a>
            </p>
        </template>


        <hr>

    </NewModalPopup>
</template>

<script setup>
  import NewModalPopup from '@/components/NewModalPopup.vue'
  import { defineProps } from 'vue'
  import { useTimetableMethods } from '@/composables/TimetableMethods'

  const { formatEventTime, formatDateTitle } = useTimetableMethods()

  // this is used? the following line tells ESLint to shut up
  // eslint-disable-next-line no-unused-vars
  const props = defineProps({
      date: Date,
      title: String,
      startTime: String,
      endTime: String,
      location: String,
      locationLink: String,
      onlineClassLink: String,
      classIf: String, // ONLIVE = online class, ONANY = hybrid class, other = in person
      lecturer: String,
      classType: String,
      roomBooking: Boolean,
      room: String,
      roomLink: String,
      desc: String,
      roomid: String
  })

  const emit = defineEmits(['close'])
</script>

<style scoped>
    .checkInContainer {
      display: flex;
    }

    .checkInButton, .checkInButtonDisabled {
      border-radius: 5px;
      height: 40px;
      width: 25%;
      font-weight: bold;
      border:0;
      color:#FFFFFF !important;
      margin-right: 20px;
    }

    .checkInButton {
      background: var(--uog-dark-blue) !important;
    }

    .checkInButtonDisabled {
      background: grey !important;
    }

    .codeInput {
      width: 50%;
      margin-right: 20px;
    }

    #classPopUp .title {
        font-weight: bold;
    }

    #classPopUp .modal-header .title {
        font-weight: normal;
        color: #1D1D1D;
    }

    #classPopUp .eventLocIcon {
        height: 22px;
        line-height: inherit;
        margin-right: 5px;
        color: var(--uog-dark-blue);
    }

    #classPopUp .eventLocContainer {
        justify-content: center;
        vertical-align: 8px;
    }

    #classPopUp .bookingItemIcon {
        color: var(--uog-dark-blue);
    }

    #classPopUp a.jsLink {
        color: var(--uog-dark-blue);
        text-decoration-line: underline;
    }

    #classPopUp p{
        color: #1D1D1D;
    }

    #classPopUp .not-supplied {
        font-style: italic;
    }

    #classPopUp .spacer {
        display:inline-block;
        width: 2px;
    }

    #classPopUp .no-location {
        display: inline-block;
        margin-bottom:0px;
    }
</style>
